import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/BusStops/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/BusStops/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/BusStops/GetById`, payload),
    Add: (payload) => Repository.post(`/api/BusStops/Add`, payload),
    Edit: (payload) => Repository.post(`/api/BusStops/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/BusStops/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/BusStops/ChangeStatus`, payload),
}